module.exports = __webpack_public_path__ + "img/ciaz-banner.27d0859b.svg";